import React from 'react';
import LanguageToggle from '../header/LanguageToggle';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const LoginHeader = ({
  logedInOrSignUp,
  hideRightSection = false,
  signInPath = '/login',
  signUpPath = '/sign-up',
  resetPasswordPath = '/reset-password',
  isAFacilitator = false,
}) => {
  return (
    <div className='sign-in-b-wrapper'>
      {!isAFacilitator && <LanguageToggle />}
      {!hideRightSection && (
        <div className='right-section ml-auto'>
          {logedInOrSignUp === 'login' ? (
            <>
              <div>
                <p>Need to Create an Account?</p>
                <p>
                  <Link to={resetPasswordPath}>
                    I forgot my username or password
                  </Link>
                </p>
              </div>
              <Link className='sign-up' to={signUpPath}>
                Create new account
              </Link>
            </>
          ) : (
            <>
              <div>
                <p>Already have an account?</p>
                <p>
                  <Link to={resetPasswordPath}>
                    I forgot my username or password
                  </Link>
                </p>
              </div>
              <Link className='sign-up' to={signInPath}>
                Sign In
              </Link>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default LoginHeader;
